import { css } from '@emotion/css';

export const attendeeEntryStyles = css`
    margin-bottom: 0.3em;
`;